var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadKsNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.375h-2.11l-1.874 1.875H17.5c.313 0 .625.313.625.625V18a.642.642 0 0 1-.625.625h-15A.617.617 0 0 1 1.875 18v-3.125c0-.313.273-.625.625-.625h3.945L4.57 12.375H2.5a2.492 2.492 0 0 0-2.5 2.5V18c0 1.406 1.094 2.5 2.5 2.5h15c1.367 0 2.5-1.094 2.5-2.5v-3.125c0-1.367-1.133-2.5-2.5-2.5zm-.625 4.063a.95.95 0 0 0-.938-.938.925.925 0 0 0-.937.938c0 .546.39.937.938.937.507 0 .937-.39.937-.938zm-7.54-1.524c.157.195.392.274.665.274.234 0 .469-.079.625-.274l5.313-5.312a.856.856 0 0 0 0-1.29.856.856 0 0 0-1.29 0l-3.71 3.711V1.438A.95.95 0 0 0 10 .5a.925.925 0 0 0-.938.938v10.585l-3.75-3.75c-.39-.351-.976-.351-1.328 0-.39.391-.39.977 0 1.329l5.352 5.312z",
    fill: "#A1C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadKsNav);
export default __webpack_public_path__ + "static/media/download-ks-nav.7c5969c5333efd77a0e3a572811bb647.svg";
export { ForwardRef as ReactComponent };